"use client";

import { usePathname } from "next/navigation";

export default function MainContainer({ children }: { children: React.ReactNode }){
  const pathname = usePathname();

  // If on homepage, just return children without any styling
  if (pathname === '/') {
    return <>{children}</>;
  }

  // For other pages, use the standard container styling
  return (
    <main className="
            flex-grow
            flex flex-col
            px-0 md:px-8
            pt-0 md:pt-[var(--nav-height)]
            pb-[var(--nav-height-mobile)] md:pb-0
          ">
      {children}
    </main>
  );
};
